<template>
    <div class="q-pa-md">
        <!-- APRTADO DEL CORREO -->
        <q-dialog v-model="dialogCorreo" persistent transition-show="flip-down" transition-hide="flip-up">
            <iframe :style="iframeStyle" ref="iframe" src="http://localhost:8080/" frameborder="0" width="100%"
                height="100%" @load="enviarComprobanteCorreo">
            </iframe>
        </q-dialog>
        <q-card class="my-card">
            <q-card-section>
                <div class="row">
                    <div class="col-3">
                        <q-icon name="mdi-close-circle-outline" size="md" class="q-mr-lg" style="cursor: pointer;"
                            color="red" @click="CierraDialog"></q-icon>
                    </div>
                    <div class="col-6">
                        <div class="text-center">
                            <q-icon name="mdi-minus" size="md" style="cursor: pointer;" color="primary"
                                @click="AnteriorPagina"></q-icon>
                            {{ page }} /{{ numPages }}
                            <q-icon name="mdi-plus" size="md" style="cursor: pointer;" color="primary"
                                @click="SiguientePagina"></q-icon>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="text-right">
                            <q-icon name="mdi-email-fast-outline" size="sm" style="cursor: pointer;" color="amber-10"
                                @click="enviarComprobanteCorreo()"></q-icon>
                            <q-icon name="mdi-download" size="sm" class="q-ml-sm" style="cursor: pointer;" color="green"
                                @click="descargarComprobante()"></q-icon>
                            <q-icon name="mdi-printer" size="sm" class="q-ml-sm" style="cursor: pointer;" color="blue"
                                @click="$refs.pdf.print()"></q-icon>
                            <q-icon name="mdi-xml" size="sm" class="q-ml-sm" style="cursor: pointer;" color="red"
                                @click="GetXML"></q-icon>
                        </div>
                    </div>
                    <div style="width: 100%">
                        <pdf ref="pdf" :src="pdfBase64" :page="page" :rotate="rotate" @progress="loadedRatio = $event"
                            @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import { format } from 'date-fns';
import { parse } from 'date-fns';
import { endOfMonth } from 'date-fns';
import { es } from 'date-fns/locale';
import moment from 'moment';
import axios from 'axios';
import { QSpinnerCube } from 'quasar';
import pdf from 'vue-pdf';
import { generarCodigoQR } from './qrcodeGenerator';
import { ComprobanteBase64 } from './ComprobanteBase64.js';
import { Pago20Base64 } from './Pago20Base64.js'

export default {
    components: {
        pdf: pdf
    },
    data() {
        return {
            iframeStyle: {
                pointerEvents: "auto", // Permite la interacción con el iframe
            },

            pdfBase64: '',
            loadedRatio: 0,
            page: 1,
            numPages: 0,
            rotate: 0,
            tipoComprobante: 'I',
            fecha: null,
            nombreArchivo: "",

            //CORREOS
            dialogCorreo: false,
            logoBase64: '',
        }
    },
    async mounted() {
        const logoURL = require('../../assets/logo_top.png')
        this.logoBase64 = await this.cargarImagenComoBase64(logoURL);
    },
    computed: {
        token() {
            return this.$store.state.auth.usuario;
        },

        folioFiscal() {
            return this.$store.state.auth.folioFiscalStore;
        },

        rfc() {
            return this.$store.state.auth.rfcStore;
        },

        vistaPrevia() {
            return this.$store.state.auth.vistaPreviaStore;
        },

        empresa() {
            return this.$store.state.auth.empresaStore;
        },

        ObjLogo() {
            return this.$store.state.auth.empresaStore.logo.base64;
        },

    },

    watch: {

    },

    created() {
        this.Iniciales();
        window.addEventListener("message", this.manejarMensaje);
    },

    beforeDestroy() {
        window.removeEventListener("message", this.manejarMensaje);
    },

    methods: {
        async Iniciales() {
            this.$q.loading.show({
                spinner: QSpinnerCube,
                spinnerColor: 'primary',
                spinnerSize: 140,
                message: 'Consultando, esprere..',
            })
            await this.VerComprobante();
            await this.GetEmpresa();
            this.$q.loading.hide()
        },

        async VerComprobante() {
            if (this.vistaPrevia.comprobante) {
                await this.VerComprobanteSinTimbrar();
            } else {
                await this.VerComprobanteTimbrado();
            }
        },

        async GetEmpresa() {
            try {
                let response = await axios.get("https://api-beta-erp.contago.com.mx/api/Empresa/GetEmpresaAsync/erp_SCA900316JP0");
                let x = response.data;
                this.$store.state.empresaStore = { ...x }
            } catch (error) {
                console.log(error)
            }
        },



        async VerComprobanteTimbrado() {
            this.splitterModel = 40
            let folioFiscal = this.vistaPrevia.folioFiscal;
            let color = '#0094CA';
            let tipoComprobanteInterno = this.vistaPrevia.tipoComprobanteInterno;
            const logoURL = require('../../assets/logo_top.png')
            this.logoBase64 = await this.cargarImagenComoBase64(logoURL);


            let colection = ""
            switch (tipoComprobanteInterno) {
                case 'FACTURA':
                    colection = 'comprobantes_emitidos'
                    break;
                case 'NOTA CREDITO':
                    colection = 'comprobantes_emitidos'
                    break;
                case 'PAGO':
                    colection = 'comprobantes_pagos'
                    break;
            }
            try {
                // console.log(item)
                let response = await axios.get('https://api-beta-erp.contago.com.mx/api/Comprobantes/GetComprobanteAsync/erp_IIA040805DZ4/' + colection + '/' + folioFiscal);
                let x = response.data;
                console.log(x)
                let extraQr = x.timbreFiscalDigital.selloCFD.slice(-8);
                const fechaT = x.timbreFiscalDigital.fechaTimbrado.replace("Z", "");
                let cadenaOriginal = '||1.1|' + x.folioFiscal + '|' + fechaT + '|LSO1306189R5|' + x.timbreFiscalDigital.selloCFD + '|' + x.timbreFiscalDigital.noCertificadoSAT + '||'
                x.timbreFiscalDigital.cadenaOriginal = cadenaOriginal;

                let codigoQR = await generarCodigoQR(x.folioFiscal, x.emisor.rfc, x.receptor.rfc, x.total, extraQr);
                let base64 = ''
                switch (tipoComprobanteInterno) {
                    case "FACTURA":
                        base64 = await ComprobanteBase64(x, x.tipoComprobanteInterno, x.estatus, color, codigoQR, this.logoBase64);
                        break;
                    case "NOTA CREDITO":
                        base64 = await ComprobanteBase64(x, x.tipoComprobanteInterno, x.estatus, color, codigoQR, this.logoBase64);
                        break;
                    case "PAGO":
                        base64 = await Pago20Base64(x, x.tipoComprobanteInterno, x.estatus, color, codigoQR, this.logoBase64);
                        break;
                }
                if (x.serie != "") {
                    this.nombreArchivo = x.folio + "_" + x.receptor.rfc + "_" + x.folioFiscal;
                } else {
                    this.nombreArchivo = x.serie + "_" + x.folio + "_" + x.receptor.rfc + "_" + x.folioFiscal;
                }
                console.log(this.nombreArchivo);
                this.pdfBase64 = 'data:application/pdf;base64,' + base64.split(',')[1];
                this.fecha = x.fecha;
            } catch (error) {
                console.log(error)
            }
        },
        cargarImagenComoBase64(url) {
            return new Promise((resolve, reject) => {
                const img = new Image()
                img.crossOrigin = 'Anonymous'
                img.onload = function () {
                    const canvas = document.createElement('canvas')
                    canvas.width = this.width
                    canvas.height = this.height
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(this, 0, 0)
                    const dataURL = canvas.toDataURL('image/png')
                    resolve(dataURL)
                }
                img.onerror = reject
                img.src = url
            })
        },
        descargarComprobante() {
            const fileName = this.nombreArchivo + ".pdf";
            const link = document.createElement("a");
            link.href = this.pdfBase64;
            link.download = fileName;
            link.click();
        },

        async GetXML() {
            const nombresMeses = [
                'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
            ];

            let folioFiscal = this.vistaPrevia.folioFiscal;
            let rfc = this.vistaPrevia.rfc;
            let fecha = new Date(this.fecha);
            let año = fecha.getFullYear();
            let mes = fecha.getMonth();
            let nombreMes = nombresMeses[mes]

            try {
                let response = await axios.get('https://api-beta-erp.contago.com.mx/api/Comprobantes/GetXmlAsync/erp_IIA040805DZ4/' + año + '/' + nombreMes + '/' + folioFiscal);
                await this.descargaComprobanteXml(response.data)
            } catch (error) {
                console.log(error)
            }
        },

        async descargaComprobanteXml(item) {
            const xmlBase64 = item
            const fileName = this.nombreArchivo + ".xml";
            const link = document.createElement("a");
            link.href = "data:text/xml;base64," + xmlBase64;
            link.download = fileName;
            link.click();
        },

        SiguientePagina() {
            let paginas = this.numPages;
            if (this.page < paginas) {
                this.page++;
            } else {
                // this.page = 1;
            }
        },

        AnteriorPagina() {
            let paginas = this.numPages;
            if (this.page > paginas) {
                this.page--;
            } else {
                this.page = 1;
            }
        },

        CierraDialog() {
            if (this.vistaPrevia.comprobante) {
                this.$emit("closeDialog");
            } else {
                this.$emit("closeDialogTimbrado");
            }
        },

        //CORREO ELECTRONICO
        enviarComprobanteCorreo() {
            const objMensajeCorreo = {
                usuario: "admin",
                asunto: "Se envía factura correspondiente",
                receptores: [
                    {
                        _id: "",
                        usuario: "",
                        nombre: "Erick Rueda",
                        correo: "erick1991_03@hotmail.com",
                        telefono: "2228074564",
                    }
                ],
                adjuntos: [
                    {
                        nombre: "",
                        tipo: "",
                        base: "",
                    }
                ]
            }
            this.dialogCorreo = true;

            setTimeout(() => {
                const iframe = this.$refs.iframe?.contentWindow;
                if (iframe) {
                    iframe.postMessage(objMensajeCorreo, "*");
                    this.dialogCorreo = true;
                } else {
                    console.error("El iframe no está listo para recibir datos.");
                }
            }, 1000); // Ajusta el tiempo según sea necesario
        },

        manejarMensaje(event) {
            if (event.data === "cerrar-dialogo") {
                this.closeDialogCorreo();
            }
        },

        closeDialogCorreo() {
            this.dialogCorreo = false;
        },

    }
}
</script>


<style lang="sass" scoped>
    .my-card
      width: 100%
    </style>
